import { render, staticRenderFns } from "./inventory_statistics.vue?vue&type=template&id=27fad4fc&scoped=true&"
import script from "./inventory_statistics.vue?vue&type=script&lang=js&"
export * from "./inventory_statistics.vue?vue&type=script&lang=js&"
import style0 from "./inventory_statistics.vue?vue&type=style&index=0&id=27fad4fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fad4fc",
  null
  
)

export default component.exports